import axios from "axios";
import queryString from "query-string";
import { Security } from "shared/utils";

const config = () => ({
  headers: {
    "x-auth-token": sessionStorage.getItem("rk") || "guest",
    "Content-Type": "application/json;charset=UTF-8"
  }
});

export const get = (url, data) => {
  return axios.get(
    `${url}?${queryString.stringify(Security.encG(data))}`,
    config()
  );
};

export const post = (url, data) =>
  axios.post(url, Security.encG(data), config());

export const put = (url, data) => axios.put(url, Security.encG(data), config());

export const patch = (url, data) =>
  axios.patch(url, Security.encG(data), config());

export const del = (url, data) =>
  axios.delete(url, { headers: config().headers, data: Security.encG(data) });

export const upload = (url, data, files) =>
  axios.post(url, Security.encU(data, files), {
    headers: {
      "x-auth-token": sessionStorage.getItem("rk") || "guest",
      "Content-Type": "multipart/form-data",
      "X-Requested-With": "XMLHttpRequest"
    }
  });
